export default {
      id: "ar_rdv_cni-usage",
      viewBox: "0 0 65 50",
      url: "../dist/images/" + "sprite.svg#ar_rdv_cni-usage",
      toString: function () {
        return this.url;
      }
    }